module.exports = __webpack_public_path__ + "assets/img/calendar.8520ba74.svg";